export default {
  archive: (state) => state.archive,
  allArchivesLoaded: (state) => state.allArchivesLoaded,
  noResult: (state) => state.noResult,
  meta: (state) => state.meta,
  writing: (state) => state.writing,
};
